const getVideoID = (string) => {
	const regexPattern =
		/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
	const match = string.match(regexPattern);
	return match ? match[1] : null;
};

const createYouTubeLinks = (pTag, videoId) => {
	const docFrag = new DocumentFragment();
	const videoWrapper = document.createElement('div');
	const videoInnerWrapper = document.createElement('div');
	const videoBtn = document.createElement('button');
	const imgEl = document.createElement('img');
	videoWrapper.classList.add('youtube-embed-wrapper');
	videoInnerWrapper.classList.add('youtube-embed-inner-wrapper');
	videoBtn.classList.add('youtube-embed-btn');
	videoBtn.dataset.videoUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
	videoBtn.addEventListener('click', (e) => replaceWithVideo(e.target));
	imgEl.classList.add('youtube-embed-thumbnail');
	imgEl.src = `//img.youtube.com/vi/${videoId}/0.jpg`;
	videoBtn.append(imgEl);
	videoInnerWrapper.append(videoBtn);
	videoWrapper.append(videoInnerWrapper);
	docFrag.append(videoWrapper);
	pTag.replaceWith(docFrag);
};

const replaceWithVideo = (clickedEl) => {
	// iframe reference:
	// <iframe width="560" height="315" src="https://www.youtube.com/embed/QMW4AqbuSGg?si=DNF_9Iikenw3DJz5" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
	const clickedElParentBtn = clickedEl.closest('.youtube-embed-btn');
	const videoUrl = clickedElParentBtn.dataset.videoUrl;
	const iframeEl = document.createElement('iframe');
	iframeEl.classList.add('youtube-embed-iframe');
	const attrs = {
		src: videoUrl,
		title: 'YouTube video player',
		frameborder: '0',
		allow: 'accelerometer; autoplay',
		autoplay: '',
		'clipboard-write': '',
		'encrypted-media': '',
		gyroscope: '',
		'picture-in-picture': '',
		'web-share': '',
		referrerpolicy: 'strict-origin-when-cross-origin',
		allowfullscreen: ''
	};
	for (const attr in attrs) {
		iframeEl.setAttribute(attr, attrs[attr]);
	}
	clickedElParentBtn.replaceWith(iframeEl);
	console.log(iframeEl);
};

const embedYouTubeVideos = () => {
	const articleBody = document.querySelector("span[itemprop='articleBody']");
	const allPTags = articleBody.querySelectorAll('p');
	for (const pTag of [...allPTags]) {
		let isEmbed = false;
		const videoId = getVideoID(pTag.textContent);
		videoId ? (isEmbed = true) : null;
		if (isEmbed && videoId.length == 11) {
			createYouTubeLinks(pTag, videoId);
		}
	}
};

window.addEventListener('DOMContentLoaded', () => {
	embedYouTubeVideos();
});
